import { render } from "./MaterialVendorStockTableRow.vue?vue&type=template&id=47bc19f7"
import script from "./MaterialVendorStockTableRow.vue?vue&type=script&lang=js"
export * from "./MaterialVendorStockTableRow.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__